import React from 'react';
import { Outlet } from 'react-router-dom';
import { App as AntApp } from 'antd';

/**
 * Layout for self-service mode - no header, no auth required
 * Each page sets its own background
 */
const SelfServiceLayout = () => {
    return (
        <AntApp>
            <Outlet />
        </AntApp>
    );
};

export default SelfServiceLayout;
